<template>
  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
      </template>
      <template #body="slotProps">
        <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
      </template>
    </Column>
    <Column
      field="SendEmailToAll"
      :header="$t('sendemailtoall')"
      key="SendEmailToAll"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="SendEmailToApprover"
      :header="$t('sendemailtapprovl')"
      key="SendEmailToApprover"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="PermitReleaseRange"
      :header="$t('permitreleaserange')"
      key="PermitReleaseRange"
      class="w-4"
    >
      <template #body="slotProps">
        <div class="grid">
          <div class="col-6">
            <CustomSelect
              v-model="slotProps.data.Hrange"
              :url="$API_URL + 'list/lookup'"
              placeholder="Please Select Hour"
              :minLength="0"
              :filter="true"
              @change="onCellEditComplete(slotProps)"
              :disabled="!canEdit"
              :params="{ group: 'RELEASE_RANGE_HOUR', allow_all: false }"
            />
          </div>
          <div class="col-6">
            <CustomSelect
              v-model="slotProps.data.Mrange"
              :url="$API_URL + 'list/lookup'"
              placeholder="Please Select Minute "
              :minLength="0"
              :filter="true"
              @change="onCellEditComplete(slotProps)"
              :disabled="!canEdit"
              :params="{ group: 'RELEASE_RANGE_MINUTES', allow_all: false }"
            />
          </div>
        </div>
      </template>
    </Column>
  </DataTable>

  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
      </template>
      <template #body="slotProps">
        <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
      </template>
    </Column>
    <Column
      field="DenyOsPermit"
      :header="$t('denyospermit')"
      key="DenyOsPermit"
      class="w-4"
    >
      <template #body="slotProps">
        <div class="grid">
          <div class="col-2">
            <YNCheckbox
              v-model="slotProps.data[slotProps.column.props.field]"
              :binary="true"
              :disabled="!canEdit"
              @change="onCellEditComplete(slotProps)"
            />
          </div>
          <div class="col-4">
            <CustomSelect
              v-model="slotProps.data.DenyOSPermitDays"
              :url="$API_URL + 'list/lookup'"
              placeholder="Please Select Days "
              :minLength="0"
              :filter="true"
              @change="onCellEditComplete(slotProps)"
              :disabled="!canEdit"
              :params="{ group: 'RELEASE_RANGE_HOUR', allow_all: false }"
            />
          </div>
          <div class="col-4">
            <CustomSelect
              v-model="slotProps.data.DenyOSPermitBy"
              :url="$API_URL + 'list/lookup'"
              placeholder="Please Select OS Method "
              :minLength="0"
              :filter="true"
              @change="onCellEditComplete(slotProps)"
              :disabled="!canEdit"
              :params="{ group: 'OS_PERMIT_BY', allow_all: false }"
            />
          </div>
        </div>
      </template>
    </Column>
    <Column
      field="InitWorkPict"
      :header="$t('initworkpict')"
      key="InitWorkPict"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="FinalWorkPict"
      :header="$t('finalworkpict')"
      key="FinalWorkPict"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
  </DataTable>

  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
      </template>
      <template #body="slotProps">
        <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
      </template>
    </Column>
    <Column
      field="DailyWorkCondPict"
      :header="$t('dailyworkcondPict')"
      key="DailyWorkCondPict"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="PermitMatrixLeveling"
      :header="$t('permitmatrixleveling')"
      key="PermitMatrixLeveling"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="MaintenanceApproval"
      :header="$t('maintenanceapproval')"
      key="MaintenanceApproval"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
  </DataTable>

  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
      </template>
      <template #body="slotProps">
        <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
      </template>
    </Column>
    <Column field="UseAgt" :header="$t('UseAgt')" key="UseAgt" class="w-4">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="WorkMatrixLeveling"
      :header="$t('WorkMatrixLeveling')"
      key="WorkMatrixLeveling"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="PermitReleaseOn"
      :header="$t('PermitReleaseOn')"
      key="PermitReleaseOn"
      class="w-4"
    >
      <template #body="slotProps">
        <CustomSelect
          v-model="slotProps.data.PermitReleaseOn"
          :url="$API_URL + 'list/lookup'"
          placeholder="Please Select Days"
          :minLength="0"
          :filter="true"
          @change="onCellEditComplete(slotProps)"
          :disabled="!canEdit"
          :params="{ group: 'RELEASE_RANGE_HOUR', allow_all: false }"
        />
      </template>
    </Column>
  </DataTable>

  <DataTable
    :loading="!header"
    :value="dataArray"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="hideRow"
  >
    <Column>
      <template #header="">
        <!-- <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail"
                    :disabled="!canEdit" /> -->
      </template>
      <template #body="slotProps">
        <!-- <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)"
                    :disabled="!canEdit" /> -->
      </template>
    </Column>
    <Column
      field="PermitOffline"
      :header="$t('PermitOffline')"
      key="PermitOffline"
      class="w-4"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column
      field="AdvancedContinuePermit"
      :header="$t('AdvancedContinuePermit')"
      key="AdvancedContinuePermit"
      class="w-8"
    >
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
     <!-- <Column field="UseAesp" :header="$t('UseAesp')" key="UseAesp" class="w-4">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="!canEdit"
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column> -->
  </DataTable>
</template>
<script>
export default {
  props: {
    dataArray: {
      type: Array,
      default: [],
    },
    dataModel: {
      type: Object,
      default: [],
    },
    mode: {
      type: String,
      default: "",
    },
    header: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      companyCode: this.$store.getters.getCompanyCode,
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.dataArray.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.dataArray[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.dataArray.splice(this.dataArray.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    editDetail(index) {
      if (this.dataArray && this.dataArray.length > 0) {
        let m = this.dataArray[index].mode;
        let test = this.dataArray[index].Hrange;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.dataArray[index].mode = this.$FORM_MODE_EDIT;
        }

        if (test === 0) {
          this.dataArray[index].Hrange = 0;
        }
      }
    },
    changever(event, e) {
      if (this.dataArray && this.dataArray.length > 0) {
        this.dataArray[event.index].Version = e == null ? "1" : e.id;
      }
    },
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
